import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesCommissionPaymentCreationView } from "src/components/views/erp/sales/salesCommissions/SalesCommissionPaymentCreationView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/salesCommissions/createPayment")({
	staticData: { title: i18n.t("commission_payment_creation"), legacyViewKey: "salesCommissionPaymentCreationView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesCommissionPaymentCreationView />;
}
